export const formDefaultValues = {
  newPassword: '',
  oldPassword: '',
}
